/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function splitPath(path) {
    return path.split('/').filter(x => x);
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function dirName(path) {
    let start = path.length - 1;
    if (path.endsWith('/')) {
        start -= 1;
    }
    const idx = path.lastIndexOf('/', start);
    if (idx < 0) {
        throw Error(`Getting directory failed on path: ${path}`);
    }
    return path.slice(0, idx);
}
